import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useCallback, useEffect, useRef, useState } from "react";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { postData, putData } from "../../Networking/Api";
import Footer from "../Footer";
import Swal from "sweetalert2";
import Loader from "../Loader";
import CustomSelect from "../CustomSelect";
import ReCAPTCHA from "react-google-recaptcha";

import { useDispatch, useSelector } from "react-redux";
import { loginPatient, selectPatient } from "../../redux/actions/userSlice";
import ClinicBookingHeader from "./ClinicBookingHeader";
import ClinicBookingFooter from "./ClinicBookingFooter";
import { decrypt, encrypt } from "../CryptoUtil";
import Loader2 from "../Loader2";
import { logEvent } from "../../ga";

// Stripe imports
import { Elements, CardElement, useStripe, useElements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

// Initialize Stripe - Replace with your actual publishable key
const stripePromise = loadStripe('pk_test_51PLjFMEAweqDK7nrcbn9WnEfU4M0hpJFW5woVN1dgF5dv6LjXK4Utf9RHcVHfkAtS7ZEvu2BASyCLwRWIUitvIQr00RUP5A1h7');

// Wrapper component to provide Stripe context
function ClinicPersonalAppointmentDetailsWrapper() {
    return (
        <Elements stripe={stripePromise}>
            <ClinicPersonalAppointmentDetails />
        </Elements>
    );
}

function ClinicPersonalAppointmentDetails() {
    const [loading, setLoading] = useState(false);
    const { clinicName, locations, patientType = 'existingPatient', insuranceType, appointmentType } = useParams();
    const navigate = useNavigate();
    const [clinicData, setClinicData] = useState({
        clinicName: "",
        logoImg: "",
        locations: [],
        selectedLocationId: "",
    });

    // Fetch clinic data for header
    useEffect(() => {
        const fetchClinicHeaderData = async () => {
            try {
                const response = await postData("clinics/getClinicInfo", {
                    clinicName: clinicName,
                    cityStreetName: locations,
                });

                if (response.code === 1) {
                    const clinicId = response.clinics.id;

                    // Fetch all locations for this clinic
                    const locationsPayload = {
                        modelName: "clinic_locations",
                        whereCondition: {
                            clinic_id: clinicId,
                            is_deleted: 0,
                            is_active: 1,
                        },
                    };
                    const locationsResponse = await postData("masters/getMasterList", locationsPayload);

                    setClinicData({
                        clinicName: response.clinics.name,
                        logoImg: response.clinics.logo_image,
                        locations: locationsResponse.code === 1 ? locationsResponse.data : [],
                        selectedLocationId: response.clinic_locations_data.id,
                    });
                }
            } catch (error) {
                console.error("Error fetching clinic header data:", error);
            }
        };

        fetchClinicHeaderData();
    }, [clinicName, locations]);

    // Handle location change from header
    const handleLocationChange = (event) => {
        const locationId = event.target.value;
        const selectedLoc = clinicData.locations.find(
            (loc) => loc.id.toString() === locationId.toString()
        );

        if (selectedLoc) {
            const formattedCity = selectedLoc.city.toLowerCase().replace(/\s+/g, "-");
            const formattedStreet = selectedLoc.street.toLowerCase().replace(/\s+/g, "-");

            // Navigate to new location with current params
            //navigate(`/clinicpersonalappoinmentdetails/${clinicName}/${formattedCity}-${formattedStreet}/${insuranceType}/${appointmentType}`, { replace: true });
            navigate(`/${clinicName}/clinicpersonalappoinmentdetails/${formattedCity}-${formattedStreet}/${insuranceType}/${appointmentType}`, { replace: true });
        }
    };

    return (
        <>
            {loading && <Loader2 />}
            <>
                <ClinicBookingHeader
                    clinicName={clinicData.clinicName}
                    logoImg={clinicData.logoImg}
                    clinicNameParam={clinicName}
                    cityStreetNameParam={locations}
                    locations={clinicData.locations}
                    selectedLocationId={clinicData.selectedLocationId}
                    onLocationChange={handleLocationChange}
                />
                <PersonalDetails loading={loading} setLoading={setLoading} />
                <ClinicBookingFooter />
            </>
        </>
    );
}

function PersonalDetails({ loading, setLoading }) {
    const navigate = useNavigate();
    const stripe = useStripe();
    const elements = useElements();

    const [userData, setUserData] = useState({
        first_name: "",
        last_name: "",
        email: "",
        phone: "",
        gender: "",
        zipcode: "",
        date_of_birth: "",
        reasonForVisit: "",
    });
    const [parentGuardianData, setParentGuardianData] = useState({
        first_name: "",
        last_name: "",
    });
    const [bookerData, setBookerData] = useState({
        name: "",
        fname: "",
        lname: "",
        email: "",
        phone: "",
    });

    // Stripe card state
    const [cardError, setCardError] = useState('');
    const [isCardComplete, setIsCardComplete] = useState(false);
    const [cardToken, setCardToken] = useState(null);

    const [relationshipToPatient, setRelationshipToPatient] = useState("");
    const [sendUpdatesToPatient, setSendUpdatesToPatient] = useState(false);
    const [bookingFor, setBookingFor] = useState("myself");

    const [verified, setVerified] = useState(false);
    const [errors, setErrors] = useState({});
    const location = useLocation();

    const { selectedAppointment } = location.state || {};

    const [patientId, setPatientId] = useState("");
    const [practitionerId, setPractitionerId] = useState("");
    const [doctorDetail, setDoctorDetail] = useState("");
    const [viewpatientId, setViewPatientId] = useState("");

    const [doctorName, setDoctorName] = useState([]);
    const [appoinmentName, setAppoinmentName] = useState("");
    const [insuranceName, setInsuranceName] = useState("");
    const [Clinicname, setClinicName] = useState("");
    const [phone, setPhone] = useState("");
    const [street, setStreet] = useState("");
    const [address, setAddress] = useState("");
    const [manualDetailsEntered, setManualDetailsEntered] = useState(false);
    const [sendOtp, setSendOtp] = useState(false);
    const [otp, setOtp] = useState("");
    const [isEmailDisabled, setIsEmailDisabled] = useState(false);
    const [user, setUser] = useState();

    const [patientTypeName, setPatientTypeName] = useState("");
    const [captchaDisabled, setcaptchaDisabled] = useState(true);
    const patientData = useSelector(selectPatient);
    const [isFieldDisabled, setIsFieldDisabled] = useState(false);

    const [clinicInfo, setClinicInfo] = useState({
        is_card: 0,
        no_show_fee: 0,
        name: ""
    });

    const {
        clinicName,
        patientType = 'existingPatient',
        insuranceType,
        appointmentType,
        type,
        locations,
        id,
    } = useParams();
    const appointmentTypeId = decrypt(decodeURIComponent(appointmentType));

    const [appointmentData, setAppointmentData] = useState("");
    const [notLogin, setNotLogin] = useState(false);
    const [captchError, setCaptchaError] = useState("");

    const [sendUpdatesTo, setSendUpdatesTo] = useState("booker");
    const [patientContactData, setPatientContactData] = useState({
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
    });
    const [countdown, setCountdown] = useState(0);
    const [timerActive, setTimerActive] = useState(false);

    const Dispatch = useDispatch();
    const recaptchaRef = useRef(null);
    // Stripe card validation function
    const validateCardWithStripe = async () => {
        if (!stripe || !elements) {
            return { error: 'Stripe not loaded' };
        }

        const cardElement = elements.getElement(CardElement);

        if (!cardElement) {
            return { error: 'Card element not found' };
        }

        try {
            const { error, token } = await stripe.createToken(cardElement);

            if (error) {
                return { error: error.message };
            }

            return { token };
        } catch (err) {
            return { error: 'Card validation failed' };
        }
    };

    // Handle card input changes
    const handleCardChange = (event) => {
        setIsCardComplete(event.complete);
        setCardError(event.error ? event.error.message : '');
    };

    useEffect(() => {
        const isLoggedIn = patientData?.isLoggedIn || false;
        setIsFieldDisabled(isLoggedIn);
    }, [patientData]);

    useEffect(() => {
        const doctorsData = JSON.parse(localStorage.getItem("doctorsData")) || [];
        setDoctorName(doctorsData[0]);
    }, []);
    useEffect(() => {
        const verifiedPatientId = localStorage.getItem("verifiedPatientId");
        const verifiedEmail = localStorage.getItem("verifiedEmail");
        const emailVerificationComplete = localStorage.getItem("emailVerificationComplete");

        if (emailVerificationComplete === "true" && verifiedPatientId && verifiedEmail) {
            setPatientId(verifiedPatientId);
            setManualDetailsEntered(false);
            setIsEmailDisabled(true);
            setSendOtp(false);
            setOtp("");

            // Update user data with verified email if needed
            if (bookingFor === "myself") {
                setUserData(prev => ({
                    ...prev,
                    email: verifiedEmail
                }));
            } else if (bookingFor === "child" || bookingFor === "someone_else") {
                setBookerData(prev => ({
                    ...prev,
                    email: verifiedEmail
                }));
            }
        }
    }, []);
    useEffect(() => {
        if (bookingFor === "child" || bookingFor === "someone_else") {
            setUserData({
                first_name: "",
                last_name: "",
                email: "",
                phone: "",
                gender: "",
                zipcode: "",
                date_of_birth: "",
                reasonForVisit: "",
            });

            const savedUserData = JSON.parse(localStorage.getItem("userCreateInfo")) || {};
            const verifiedEmail = localStorage.getItem("verifiedEmail");
            const verifiedPatientId = localStorage.getItem("verifiedPatientId");

            if (Array.isArray(savedUserData)) {
                const loggedInUser = savedUserData[0] || {};
                setBookerData({
                    name: `${loggedInUser.first_name || ""} ${loggedInUser.last_name || ""}`.trim(),
                    fname: `${loggedInUser.first_name || ""}`.trim(),
                    lname: `${loggedInUser.last_name || ""}`.trim(),
                    email: verifiedEmail || loggedInUser.email || "", // Use verified email first
                    phone: loggedInUser.phone || "",
                });

                if ((verifiedPatientId && verifiedEmail) || (loggedInUser.id && loggedInUser.email)) {
                    setPatientId(verifiedPatientId || loggedInUser.id);
                    setManualDetailsEntered(false);
                    setIsEmailDisabled(true);
                } else {
                    // Only reset verification state if no verification exists
                    if (!verifiedPatientId) {
                        setPatientId(null);
                        setManualDetailsEntered(true);
                        setIsEmailDisabled(false);
                        setSendOtp(false);
                        setOtp("");
                    }
                }
            } else {
                setBookerData({
                    name: `${savedUserData.first_name || ""} ${savedUserData.last_name || ""}`.trim(),
                    fname: `${savedUserData.first_name || ""}`.trim(),
                    lname: `${savedUserData.last_name || ""}`.trim(),
                    email: verifiedEmail || savedUserData.email || "", // Use verified email first
                    phone: savedUserData.phone || "",
                });

                if ((verifiedPatientId && verifiedEmail) || (savedUserData.id && savedUserData.email)) {
                    setPatientId(verifiedPatientId || savedUserData.id);
                    setManualDetailsEntered(false);
                    setIsEmailDisabled(true);
                } else {
                    // Only reset verification state if no verification exists
                    if (!verifiedPatientId) {
                        setPatientId(null);
                        setManualDetailsEntered(true);
                        setIsEmailDisabled(false);
                        setSendOtp(false);
                        setOtp("");
                    }
                }
            }
        }
    }, [bookingFor]);

    useEffect(() => {
        if (bookingFor === "myself") {
            const savedUserData = JSON.parse(localStorage.getItem("userCreateInfo")) || {};
            const verifiedEmail = localStorage.getItem("verifiedEmail");
            const verifiedPatientId = localStorage.getItem("verifiedPatientId");

            if (!savedUserData.email && !verifiedEmail) {
                // Only reset if not already verified
                if (!verifiedPatientId) {
                    setManualDetailsEntered(true);
                    setPatientId(null);
                    setIsEmailDisabled(false);
                }
            }

            if (Array.isArray(savedUserData)) {
                if (savedUserData[0]?.email || verifiedEmail) {
                    setManualDetailsEntered(false);
                    setPatientId(verifiedPatientId || savedUserData[0]?.id || null);
                    setUserData({
                        ...savedUserData[0],
                        email: verifiedEmail || savedUserData[0]?.email || "" // Use verified email first
                    });
                    setIsEmailDisabled(true);
                } else {
                    // Only reset if not already verified
                    if (!verifiedPatientId) {
                        setManualDetailsEntered(true);
                        setPatientId(null);
                        setIsEmailDisabled(false);
                    }
                    setUserData({
                        ...savedUserData[0],
                        email: verifiedEmail || savedUserData[0]?.email || ""
                    });
                }
            } else {
                if (savedUserData.email || verifiedEmail) {
                    setManualDetailsEntered(false);
                    setPatientId(verifiedPatientId || savedUserData.id || null);
                    setUserData({
                        ...savedUserData,
                        email: verifiedEmail || savedUserData.email || "" // Use verified email first
                    });
                    setIsEmailDisabled(true);
                } else {
                    // Only reset if not already verified
                    if (!verifiedPatientId) {
                        setManualDetailsEntered(true);
                        setPatientId(null);
                        setIsEmailDisabled(false);
                    }
                    setUserData({
                        ...savedUserData,
                        email: verifiedEmail || savedUserData.email || ""
                    });
                }
            }

            // Only reset OTP state if not already verified
            if (!verifiedPatientId) {
                setSendOtp(false);
                setOtp("");
            }
        } else {
            setUserData({
                first_name: "",
                last_name: "",
                email: "",
                phone: "",
                gender: "",
                zipcode: "",
                date_of_birth: "",
                reasonForVisit: "",
            });
        }

        const appointDetails = JSON.parse(localStorage.getItem("selectedAppointment")) || {};
        setAppointmentData(appointDetails);
        setPractitionerId(appointDetails.practitioner_id);
    }, [bookingFor]); // Remove patientId from dependency array

    const today = new Date();

    useEffect(() => {
        if (practitionerId) {
            getPractitionerList(practitionerId);
        }
    }, [practitionerId]);

    useEffect(() => {
        const fetchOptions = async () => {
            try {
                const response = await postData("clinics/getClinicInfo", {
                    clinicName: clinicName,
                    cityStreetName: locations,
                });

                const data = response;
                setClinicName(data.clinics.name);
                setStreet(data.clinic_locations_data.street);
                setPhone(data.clinic_locations_data.phone);

                setClinicInfo({
                    is_card: data.clinics.is_card || 0,
                    no_show_fee: data.clinics.no_show_fee || 0,
                    name: data.clinics.name
                });

                const { street, city, state, country, zipcode } =
                    data.clinic_locations_data;
                const fullAddress = `${street}, ${city}, ${state}, ${country}, ${zipcode}`;
                setAddress(fullAddress);
            } catch (error) {
                console.log("Error fetching data:", error);
            }
        };

        fetchOptions();
    }, [clinicName, locations]);

    const validateForm = async () => {
        let isValid = true;
        const errors = {};

        // **IMPORTANT: Only validate patient contact data when in share appointment flow**
        if (bookingFor === "someone_else" && sendUpdatesTo === "patient") {
            // For share appointment flow, ONLY validate the 4 patient contact fields

            // Validate first name
            if (!patientContactData.firstName || !patientContactData.firstName.trim()) {
                isValid = false;
                errors.patientContactFirstName = "Patient first name is required";
            }

            // Validate last name  
            if (!patientContactData.lastName || !patientContactData.lastName.trim()) {
                isValid = false;
                errors.patientContactLastName = "Patient last name is required";
            }

            // Validate patient contact email
            if (!patientContactData.email || !patientContactData.email.trim()) {
                isValid = false;
                errors.patientContactEmail = "Patient email is required";
            } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(patientContactData.email)) {
                isValid = false;
                errors.patientContactEmail = "Invalid email format";
            }

            // **SKIP ALL OTHER VALIDATIONS** for share appointment flow
            setErrors(errors);
            return isValid;
        }

        // **REGULAR BOOKING FLOW VALIDATIONS** - Only run when NOT in share appointment flow

        // Patient data validation for regular bookings
        if (!userData.first_name) {
            isValid = false;
            errors.first_name = "First Name Is Required";
        }
        if (!userData.last_name) {
            isValid = false;
            errors.last_name = "Last Name Is Required";
        }

        // For "myself" bookings, validate patient email
        // For other bookings, patient email is not required as notifications go elsewhere
        if (bookingFor === "myself") {
            if (!userData.email) {
                isValid = false;
                errors.email = "Email Is Required.";
            } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(userData.email)) {
                isValid = false;
                errors.email = "Invalid Email Format.";
            }
        }

        if (!userData.gender) {
            isValid = false;
            errors.gender = "Sex Is Required";
        }
        if (!userData.zipcode) {
            isValid = false;
            errors.zipcode = "Zipcode Is Required";
        } else if (!/^\d{5}(-\d{4})?$/.test(userData.zipcode)) {
            isValid = false;
            errors.zipcode = "Invalid Zip Code Format";
        }
        if (!userData.date_of_birth) {
            isValid = false;
            errors.date_of_birth = "Date Of Birth Is Required";
        }
        if (!userData.reasonForVisit) {
            isValid = false;
            errors.reasonForVisit = "Reason For Visit Is Required";
        }

        // Validate booker data for child bookings
        if (bookingFor === "child") {
            // Validate booker email (parent/guardian email)
            if (!bookerData.email.trim()) {
                isValid = false;
                errors.bookerEmail = "Your email is required";
            } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(bookerData.email)) {
                isValid = false;
                errors.bookerEmail = "Invalid email format";
            }

            // Validate booker phone
            if (!bookerData.phone.trim()) {
                isValid = false;
                errors.bookerPhone = "Your phone number is required";
            } else if (bookerData.phone.replace(/\D/g, "").length < 10) {
                isValid = false;
                errors.bookerPhone = "Phone number must contain 10 digits";
            }

            // Validate relationship
            if (!relationshipToPatient) {
                isValid = false;
                errors.relationship = "Relationship to patient is required";
            }

            // Validate parent/guardian names
            if (!parentGuardianData.first_name.trim()) {
                isValid = false;
                errors.parentFirstName = "Parent/Guardian first name is required";
            }
            if (!parentGuardianData.last_name.trim()) {
                isValid = false;
                errors.parentLastName = "Parent/Guardian last name is required";
            }
        }

        // Validate booker data for someone_else bookings when booker is selected
        if (bookingFor === "someone_else" && sendUpdatesTo === "booker") {
            // Validate first name and last name separately
            if (!bookerData.fname || !bookerData.fname.trim()) {
                isValid = false;
                errors.bookerFirstName = "First name is required";
            }
            if (!bookerData.lname || !bookerData.lname.trim()) {
                isValid = false;
                errors.bookerLastName = "Last name is required";
            }

            // Validate booker email
            if (!bookerData.email.trim()) {
                isValid = false;
                errors.bookerEmail = "Your email is required";
            } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(bookerData.email)) {
                isValid = false;
                errors.bookerEmail = "Invalid email format";
            }

            // Validate booker phone
            if (!bookerData.phone.trim()) {
                isValid = false;
                errors.bookerPhone = "Your phone number is required";
            } else if (bookerData.phone.replace(/\D/g, "").length < 10) {
                isValid = false;
                errors.bookerPhone = "Phone number must contain 10 digits";
            }
        }

        // Stripe card validation if clinic requires credit card
        if (clinicInfo.is_card === 1) {
            if (!stripe || !elements) {
                isValid = false;
                errors.card = "Payment system not ready. Please wait and try again.";
            } else if (!isCardComplete) {
                isValid = false;
                errors.card = "Please enter complete card details.";
            } else {
                // Validate card with Stripe
                const cardValidation = await validateCardWithStripe();
                if (cardValidation.error) {
                    isValid = false;
                    errors.card = cardValidation.error;
                } else {
                    setCardToken(cardValidation.token);
                }
            }
        }

        setErrors(errors);
        return isValid;
    };

    function formatphoneNumber(value) {
        const numbersOnly = value.replace(/[^\d+]/g, "");
        if (numbersOnly.length <= 3) {
            return numbersOnly;
        } else if (numbersOnly.length <= 6) {
            return `(${numbersOnly.slice(0, 3)})-${numbersOnly.slice(3)}`;
        } else {
            return `(${numbersOnly.slice(0, 3)}) ${numbersOnly.slice(
                3,
                6
            )}-${numbersOnly.slice(6)}`;
        }
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setErrors({ ...errors, [name]: "" });
        if (name === "first_name" || name === "last_name") {
            let alphabeticValue = value.replace(/[^A-Za-z\s]/g, "");
            setUserData((prevUserData) => ({
                ...prevUserData,
                [name]: alphabeticValue,
            }));
            return;
        }

        if (name === "phone") {
            const formattedValue = formatphoneNumber(value);

            if (formattedValue !== value) {
                setUserData((prevUserData) => ({
                    ...prevUserData,
                    [name]: formattedValue,
                }));
                return;
            }
        }
        if (name === "zipcode") {
            let numericValue = value.replace(/[^\d]/g, "");
            if (numericValue.length > 5) {
                numericValue = numericValue.slice(0, 5) + "-" + numericValue.slice(5);
            }

            setUserData((prevUserData) => ({
                ...prevUserData,
                [name]: numericValue,
            }));
            return;
        }

        if (name === "gender") {
            const characterValue = value.replace(/[^a-zA-Z]/g, "");
            if (characterValue !== value) {
                setUserData((prevUserData) => ({
                    ...prevUserData,
                    [name]: characterValue,
                }));
                return;
            }
        }
        setUserData((prevUserData) => ({
            ...prevUserData,
            [name]: value,
        }));
    };

    const handleParentGuardianChange = (e) => {
        const { name, value } = e.target;

        if (name === "first_name" || name === "last_name") {
            let alphabeticValue = value.replace(/[^A-Za-z\s]/g, "");
            setParentGuardianData((prevData) => ({
                ...prevData,
                [name]: alphabeticValue,
            }));
            return;
        }

        if (name === "phone") {
            const formattedValue = formatphoneNumber(value);
            if (formattedValue !== value) {
                setParentGuardianData((prevData) => ({
                    ...prevData,
                    [name]: formattedValue,
                }));
                return;
            }
        }

        if (name === "gender") {
            const characterValue = value.replace(/[^a-zA-Z]/g, "");
            if (characterValue !== value) {
                setParentGuardianData((prevData) => ({
                    ...prevData,
                    [name]: characterValue,
                }));
                return;
            }
        }

        setParentGuardianData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleBookerDataChange = (e) => {
        const { name, value } = e.target;

        if (name === "name") {
            let alphabeticValue = value.replace(/[^A-Za-z\s]/g, "");
            setBookerData((prevData) => ({
                ...prevData,
                [name]: alphabeticValue,
            }));
            return;
        }

        if (name === "phone") {
            const formattedValue = formatphoneNumber(value);
            if (formattedValue !== value) {
                setBookerData((prevData) => ({
                    ...prevData,
                    [name]: formattedValue,
                }));
                return;
            }
        }

        setBookerData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const getPractitionerList = async (practitionerId) => {
        try {
            const payload = {
                modelName: "practitioners",
                whereCondition: {
                    id: practitionerId,
                },
            };
            const response = await postData("masters/getMasterList", payload);

            setDoctorDetail(response.data[0]);
            localStorage.setItem("doctorsData", JSON.stringify(response.data));
        } catch (error) {
            console.error("Error fetching insurance options:", error);
        }
    };

    useEffect(() => {
        if (patientType === "newPatient" || patientType === "existingPatient") {
            setPatientTypeName(
                patientType === "newPatient" ? "New Patient" : "Existing Patient"
            );
        }

        const getAppointmentType = async () => {
            try {
                const payload = {
                    modelName: "clinic_services",
                    whereCondition: {
                        id: appointmentTypeId,
                    },
                };
                const response = await postData("masters/getMasterList", payload);
                setAppoinmentName(response.data[0]);
            } catch (error) {
                console.error("Error fetching appointments:", error);
            }
        };
        getAppointmentType();
    }, [appointmentTypeId, patientType]);

    useEffect(() => {
        if (insuranceType === "other" || insuranceType === "noInsurance") {
            setInsuranceName(insuranceType === "other" ? "Other" : "No Insurance");
        } else {
            const getInsuranceType = async () => {
                try {
                    const payload = {
                        modelName: "clinic_insurances",
                        whereCondition: {
                            id: insuranceType,
                        },
                        relations: [
                            {
                                module: "insurance_masters",
                            },
                            {
                                module: "health_insurance_carrier_master",
                            },
                        ],
                    };
                    const response = await postData("masters/getMasterList", payload);
                    setInsuranceName(response.data[0]);
                } catch (error) {
                    console.error("Error fetching insurance options:", error);
                }
            };
            getInsuranceType();
        }
    }, [insuranceType]);

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const options = { year: "numeric", month: "2-digit", day: "2-digit" };
        return date.toLocaleDateString("en-US", options);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const isFormValid = await validateForm();

        if (isFormValid) {
            // Special handling for "Share Appointment" flow
            if (bookingFor === "someone_else" && sendUpdatesTo === "patient") {
                try {
                    setLoading(true);

                    // Get booker information from localStorage
                    const savedUserData = JSON.parse(localStorage.getItem("userCreateInfo")) || {};
                    const bookerName = Array.isArray(savedUserData)
                        ? `${savedUserData[0]?.first_name || ""} ${savedUserData[0]?.last_name || ""}`.trim()
                        : `${savedUserData.first_name || ""} ${savedUserData.last_name || ""}`.trim();

                    const bookerEmail = Array.isArray(savedUserData)
                        ? savedUserData[0]?.email || ""
                        : savedUserData.email || "";

                    // Prepare API payload for sending appointment authentication
                    const authPayload = {
                        email: patientContactData.email,
                        bookerName: bookerName || "Unknown Booker",
                        bookerEmail: bookerEmail,
                        organizationName: clinicInfo.name || Clinicname,
                        link: "https://app.samarawell.com/"
                    };

                    console.log("Sending appointment authentication:", authPayload);

                    // Call the sentAppointmentAuthentication API
                    const authResponse = await postData("demo/sentAppointmentInvitation", authPayload);

                    if (authResponse.code === 1) {
                        // Create appointment data for storage
                        const shareAppointmentPayload = {
                            // Patient contact information for sharing
                            patientContactData: {
                                firstName: patientContactData.firstName,
                                lastName: patientContactData.lastName,
                                email: patientContactData.email,
                                phone: patientContactData.phone,
                            },

                            // Booker information
                            bookerData: {
                                name: bookerName,
                                email: bookerEmail,
                            },

                            // Appointment details from localStorage
                            appointmentData: appointmentData,

                            // Clinic and practitioner information
                            clinicInfo: {
                                name: clinicInfo.name || Clinicname,
                                address: address,
                                phone: phone,
                            },

                            // Doctor information
                            doctorInfo: {
                                name: doctorDetail?.f_name
                                    ? `${doctorDetail?.f_name} ${doctorDetail?.l_name}`
                                    : `${doctorName?.f_name} ${doctorName?.l_name}`,
                                specialty: doctorDetail?.taxonomy_description?.trim() ||
                                    doctorName?.taxonomy_description?.trim(),
                            },

                            // Service information
                            serviceInfo: {
                                name: appoinmentName.services,
                                duration: appoinmentName.duration,
                                patientType: patientTypeName,
                            },

                            // Insurance information
                            insuranceInfo: {
                                type: insuranceType,
                                name: insuranceName,
                            },

                            // Authentication response data
                            authResponse: authResponse.data
                        };

                        // Store the share appointment data for the details page
                        localStorage.setItem("shareAppointmentData", JSON.stringify(shareAppointmentPayload));

                        setLoading(false);

                        // Show success message for sharing
                        Swal.fire({
                            title: "Success",
                            text: `Appointment invitation shared successfully with: ${patientContactData.email}`,
                            icon: "success",
                            showConfirmButton: true,
                        }).then(() => {
                            // Navigate to a special share appointment details page
                            navigate(`/clinicshareappointmentdetails`);
                        });

                    } else {
                        setLoading(false);
                        Swal.fire({
                            title: "Error",
                            text: authResponse.message || "Failed to send appointment authentication.",
                            icon: "error",
                            showConfirmButton: true,
                        });
                    }

                } catch (error) {
                    setLoading(false);
                    console.error("Error sending appointment authentication:", error);

                    let errorMessage = "Failed to send appointment authentication. Please try again.";
                    if (error.response?.data?.message) {
                        errorMessage = error.response.data.message;
                    }

                    Swal.fire({
                        title: "Error",
                        text: errorMessage,
                        icon: "error",
                        showConfirmButton: true,
                    });
                }
                return; // Exit early for share appointment flow
            }

            // Regular booking flow continues here...
            if (patientId == null || patientId == "null") {
                Swal.fire({
                    title: "Error",
                    text: "Please Send OTP and verify email.",
                    icon: "error",
                    showConfirmButton: true,
                }).then(() => {
                    return false;
                });
            } else {
                const dobFormatted = formatDate(userData.date_of_birth);

                try {
                    setLoading(true);
                    // Update patient info only for "myself" bookings
                    if (bookingFor === "myself") {
                        const payload2 = {
                            modelName: "patients",
                            id: patientId,
                            inputData: {
                                first_name: userData.first_name,
                                last_name: userData.last_name,
                                zipcode: userData.zipcode,
                                gender: userData.gender,
                                latitude: "00",
                                longitude: "00",
                                phone: userData.phone,
                                date_of_birth: userData.date_of_birth,
                            },
                        };
                        const response2 = await postData(
                            "masters/createAndUpdateMaster",
                            payload2
                        );
                        var patientInfo = {};
                        patientInfo = response2.data[0];
                        localStorage.setItem("userCreateInfo", JSON.stringify(patientInfo));
                        Dispatch(
                            loginPatient({
                                isLoggedIn: true,
                            })
                        );
                    }

                    // Create patient_familys record for "child" or "someone_else" bookings
                    let patientFamilyId = null;

                    if (bookingFor === "child" || bookingFor === "someone_else") {
                        const patientFamilyPayload = {
                            modelName: "patient_familys",
                            inputData: {
                                patient_id: patientId, // The booker's patient ID
                                first_name: userData.first_name,
                                last_name: userData.last_name,
                                gender: userData.gender,
                                date_of_birth: userData.date_of_birth,
                                address: userData.zipcode,
                                phone: userData.phone || "", // Patient's phone if available
                                email: userData.email || "", // Patient's email if available

                                // For child bookings
                                ...(bookingFor === "child" && {
                                    relationship: relationshipToPatient,
                                    parent_guardian_first_name: parentGuardianData.first_name,
                                    parent_guardian_last_name: parentGuardianData.last_name,
                                }),

                                // For someone_else bookings when booker receives updates
                                ...(bookingFor === "someone_else" && sendUpdatesTo === "booker" && {
                                    relationship: "someone_else",
                                    parent_guardian_first_name: bookerData.fname,
                                    parent_guardian_last_name: bookerData.lname,
                                    booker_email: bookerData.email,
                                    booker_phone: bookerData.phone,
                                }),

                                is_active: 1,
                                created_at: new Date().toISOString(),
                            },
                        };

                        console.log("Creating patient_familys record:", patientFamilyPayload);

                        const patientFamilyResponse = await postData(
                            "masters/createAndUpdateMaster",
                            patientFamilyPayload
                        );

                        if (patientFamilyResponse.code === 1) {
                            patientFamilyId = patientFamilyResponse.data[0].id;
                            console.log("Patient family record created with ID:", patientFamilyId);
                        } else {
                            console.error("Failed to create patient family record:", patientFamilyResponse.message);
                            throw new Error("Failed to create patient family record");
                        }
                    }


                    const appointmentPayload = {
                        patient_id: patientId,
                        dob: dobFormatted,
                        firstname: userData.first_name,
                        lastname: userData.last_name,
                        email: userData.email,
                        zipcode: userData.zipcode,
                        gender: userData.gender,
                        phone: userData.phone,
                        reasonForVisit: userData.reasonForVisit,
                        patientType: patientType,
                        insuranceType: insuranceType,
                        appointmentType: appointmentTypeId,
                        appointmentid: appointmentData.athena_appointment_id,
                        cardToken: cardToken?.id || null,
                        no_show_fee: clinicInfo.no_show_fee || 0,

                        // ADD THESE FIELDS THAT YOUR BACKEND EXPECTS:
                        bookingType: bookingFor, // "myself", "child", "someone_else"
                        sendUpdatesTo: sendUpdatesTo, // "booker" or "patient"

                        // Booker data (for child and someone_else bookings)
                        bookerData: {
                            name: bookerData.name,
                            fname: bookerData.fname,
                            lname: bookerData.lname,
                            email: bookerData.email,
                            phone: bookerData.phone,
                        },

                        // Patient contact data (for someone_else when patient receives updates)
                        patientContactData: {
                            name: patientContactData.name,
                            firstName: patientContactData.firstName, // Add this if you have it
                            lastName: patientContactData.lastName,   // Add this if you have it
                            email: patientContactData.email,
                            phone: patientContactData.phone,
                        },

                        // Parent/Guardian data (for child bookings)
                        parentGuardianData: {
                            first_name: parentGuardianData.first_name,
                            last_name: parentGuardianData.last_name,
                        },

                        // Relationship (for child bookings)
                        relationshipToPatient: relationshipToPatient,

                        inputData: {
                            phone: userData.phone,
                            is_patient_family: bookingFor === "myself" ? 0 : 1, // 0 for myself, 1 for others
                            patient_id: patientId,
                            patient_family_id: bookingFor === "myself" ? 0 : patientFamilyId, // Use patientId as family_id for others
                            clinic_id: 1,
                            practitioner_id: appointmentData.practitioner_id,
                            price: 0,
                            appointment_date_time: appointmentData.available_date_time,
                            payment_details: cardToken ? JSON.stringify({
                                last4: cardToken.card.last4,
                                brand: cardToken.card.brand,
                                exp_month: cardToken.card.exp_month,
                                exp_year: cardToken.card.exp_year,
                                token_id: cardToken.id,
                                amount: clinicInfo.no_show_fee || 0,
                            }) : "NA",
                            status: "Booked",
                            practitioner_calendars_id: appointmentData.id,
                            insurance:
                                insuranceType === "other"
                                    ? "Other"
                                    : insuranceType === "noInsurance"
                                        ? "No Insurance"
                                        : null,
                            patient_type_id: patientType === "newPatient" ? 1 : 2,
                            clinic_insurance_id:
                                insuranceType === "other" || insuranceType === "noInsurance"
                                    ? null
                                    : insuranceType,
                            clinic_service_id: appointmentTypeId,
                            appointments_from: appointmentData.appointment_from,
                        },
                        practitionerCalendarsData: appointmentData,
                    };

                    console.log("payload", appointmentPayload);
                    const response = await putData(
                        "athenaapi/createLocalAppointmentBook",
                        appointmentPayload
                    );

                    if (response.code === 1) {
                        setLoading(false);
                        Swal.fire({
                            title: "Success",
                            text: "Appointment Booked Successfully",
                            icon: "success",
                            showConfirmButton: true,
                        }).then(() => {
                            setViewPatientId(response.data.id);
                            const viewId = response.data.id;
                            logEvent("Appointment", "Book", "Patient booked an appointment");
                            navigate(`/clinicbookedappointmentDetails/${viewId}`);
                            localStorage.setItem("patientId", patientId);
                        });
                    } else if (response.code === 0) {
                        setLoading(false);
                        Swal.fire({
                            title: "Error",
                            text: response.message,
                            icon: "error",
                            showConfirmButton: true,
                        }).then(() => { });
                        console.error("Failed to create appointment:", response.message);
                    } else {
                        setLoading(false);
                        Swal.fire({
                            title: "Error",
                            text: response.message,
                            icon: "error",
                            showConfirmButton: true,
                        }).then(() => { });
                        console.error("Failed to create appointment:", response.message);
                    }
                } catch (error) {
                    setLoading(false);
                    console.error("Error creating appointment:", error);
                }
            }
        }
    };

    const onChange = async (value) => {
        // For share appointment flow, skip patientId check entirely
        if (bookingFor === "someone_else" && sendUpdatesTo === "patient") {
            const isFormValid = await validateForm();
            if (isFormValid) {
                setVerified(true);
                setCaptchaError("");
            } else {
                setTimeout(() => {
                    Swal.fire({
                        title: "Error",
                        text: "Please fill out all patient contact fields before verifying.",
                        icon: "error",
                    }).then(() => {
                        try {
                            if (recaptchaRef.current) {
                                recaptchaRef.current.reset();
                                console.log("ReCAPTCHA reset successfully.");
                            }
                        } catch (error) {
                            console.error("An error occurred while resetting ReCAPTCHA:", error);
                        }
                    });
                }, 500);
            }
            return;
        }

        // Regular booking flow - check patientId first
        if (patientId == null || patientId === "null") {
            Swal.fire({
                title: "Error",
                text: "Please Send OTP and verify email Before Verifying Captcha.",
                icon: "error",
                showConfirmButton: true,
            }).then(() => {
                try {
                    if (recaptchaRef.current) {
                        recaptchaRef.current.reset();
                        console.log("ReCAPTCHA reset successfully.");
                    }
                } catch (error) {
                    console.error("An error occurred while resetting ReCAPTCHA:", error);
                }
            }, 500);
            return;
        }

        const isFormValid = await validateForm();
        if (isFormValid) {
            setVerified(true);
            setCaptchaError("");
        } else {
            setTimeout(() => {
                Swal.fire({
                    title: "Error",
                    text: "Please Fill Out All Required Fields Before Verifying.",
                    icon: "error",
                }).then(() => {
                    try {
                        if (recaptchaRef.current) {
                            recaptchaRef.current.reset();
                            console.log("ReCAPTCHA reset successfully.");
                        }
                    } catch (error) {
                        console.error("An error occurred while resetting ReCAPTCHA:", error);
                    }
                });
            }, 500);
        }
    };

    // Add countdown timer effect
    useEffect(() => {
        let timer = null;
        if (timerActive && countdown > 0) {
            timer = setTimeout(() => {
                setCountdown(countdown - 1);
            }, 1000);
        } else if (countdown === 0) {
            setTimerActive(false);
        }
        return () => {
            if (timer) clearTimeout(timer);
        };
    }, [countdown, timerActive]);

    // Start the countdown timer
    const startCountdown = () => {
        setCountdown(60);
        setTimerActive(true);
    };

    const handleVerifyEmail = async (value) => {
        if (!value) {
            Swal.fire({
                title: "Error",
                text: "Email Is Required",
                icon: "error",
            });
            return;
        }
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
            Swal.fire({
                title: "Error",
                text: "Please Enter A Valid Email",
                icon: "error",
            });
            return;
        }

        try {
            setLoading(true);

            // Send code via API (similar to AppointmentAuthentication)
            const payload = {
                email: value
            };

            const response = await postData("patients/sentOtpRequest", payload);
            setLoading(false);

            if (response.code === 1) {
                Swal.fire({
                    title: "Success",
                    text: `Verification code sent to ${value}. Please check your email.`,
                    icon: "success",
                });
                setSendOtp(true);
                setIsEmailDisabled(true);
                startCountdown(); // Start countdown timer
            } else if (response.code === 0) {
                Swal.fire({
                    title: "Error",
                    text: response.message || "Failed to send verification code",
                    icon: "error",
                });
            }
        } catch (error) {
            setLoading(false);
            console.error("Error sending verification code:", error);
            Swal.fire({
                title: "Error",
                text: "Failed to send verification code. Please try again.",
                icon: "error",
            });
        }
    };

    const handleVerifyOtp = async (inputOtp, email) => {
        try {
            setLoading(true);

            // Call existing patient OTP verification API
            const payload1 = {
                email: email,
                otp: inputOtp,
            };

            const response1 = await postData("patients/verifyOtp", payload1);
            setLoading(false);

            if (response1.status === 200) {
                if (response1.code === 1) {
                    Swal.fire({
                        title: "Success",
                        text: "Email verified successfully",
                        icon: "success",
                    });

                    const verifiedPatientId = response1.data.patientId;
                    setPatientId(verifiedPatientId);
                    setSendOtp(false);
                    setManualDetailsEntered(false);
                    setNotLogin(true);
                    setTimerActive(false);
                    setCountdown(0);

                    // Store verification state in localStorage to persist across tab changes
                    localStorage.setItem("verifiedPatientId", verifiedPatientId);
                    localStorage.setItem("verifiedEmail", email);
                    localStorage.setItem("emailVerificationComplete", "true");

                    if (bookingFor === "child" || bookingFor === "someone_else") {
                        setBookerData(prev => ({
                            ...prev,
                            email: email
                        }));
                    }
                } else if (response1.code === 0) {
                    Swal.fire({
                        title: "Error",
                        text: response1.message || "Please Enter A Valid OTP",
                        icon: "error",
                    });
                } else {
                    Swal.fire({
                        title: "Error",
                        text: response1.message || "Unexpected error occurred. Please try again.",
                        icon: "error",
                    });
                }
            } else {
                Swal.fire({
                    title: "Error",
                    text: "An unexpected error occurred. Please try again.",
                    icon: "error",
                });
            }
        } catch (error) {
            setLoading(false);
            Swal.fire({
                title: "Error",
                text: "Error verifying code. Please try again later.",
                icon: "error",
            });
            console.error("Error verifying code:", error);
        }
    };
    // Add resend verification function
    const handleResendVerification = async (email) => {
        try {
            setLoading(true);

            const payload = {
                email: email
            };

            const response = await postData("patients/sentOtpRequest", payload);
            setLoading(false);

            if (response.code === 1) {
                Swal.fire({
                    title: "Success",
                    text: "New verification code sent successfully.",
                    icon: "success",
                });
                startCountdown(); // Restart countdown
            } else {
                Swal.fire({
                    title: "Error",
                    text: "Failed to resend verification code. Please try again.",
                    icon: "error",
                });
            }
        } catch (error) {
            setLoading(false);
            Swal.fire({
                title: "Error",
                text: "Failed to resend verification code. Please try again.",
                icon: "error",
            });
        }
    };

    const handleOtpChange = (e) => {
        const { value } = e.target;
        if (/^\d*$/.test(value)) {
            setOtp(value);
        }
    };

    const handlePatientContactChange = (e) => {
        const { name, value } = e.target;

        if (name === "firstName" || name === "lastName") {
            let alphabeticValue = value.replace(/[^A-Za-z\s]/g, "");
            setPatientContactData((prevData) => ({
                ...prevData,
                [name]: alphabeticValue,
            }));
            return;
        }

        if (name === "phone") {
            const formattedValue = formatphoneNumber(value);
            if (formattedValue !== value) {
                setPatientContactData((prevData) => ({
                    ...prevData,
                    [name]: formattedValue,
                }));
                return;
            }
        }

        setPatientContactData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    return (
        <>
            <section className="w-full mt-4">
                <div className="container mx-auto px-4">
                    <span
                        onClick={() => {
                            const encryptedappointmentTypeId = encrypt(
                                appointmentTypeId.toString()
                            );
                            const urlSafeAppointmentTypeId = encodeURIComponent(
                                encryptedappointmentTypeId
                            );
                            // navigate(
                            //     `/clinicaddbookingdetails/${clinicName}/${locations}/${insuranceType}/${urlSafeAppointmentTypeId}`
                            // );
                            navigate(
                                `/${clinicName}/clinicaddbookingdetails/${locations}/${insuranceType}/${urlSafeAppointmentTypeId}`
                            );
                            localStorage.removeItem("selectedSlot");
                            localStorage.removeItem("selectedAppointment");
                        }}
                        className="font-fontPoppins text-sm font-semibold cursor-pointer"
                    >
                        <i className="fa-solid fa-long-arrow-left text-gray-300"></i>{" "}
                        Personal & Appointment Details
                    </span>

                    {/* Who are you booking for section */}
                    <div className="w-full my-6">
                        <h2 className="font-fontPoppins text-xl font-semibold text-gray-800 mb-4">
                            Who are you booking for?
                        </h2>
                        <div className="flex flex-wrap gap-4 justify-center md:justify-start">
                            <button
                                onClick={() => setBookingFor("myself")}
                                className={`flex flex-col items-center justify-center w-64 h-24 rounded-lg border-2 transition-all duration-200 ${bookingFor === "myself"
                                    ? "border-black bg-white shadow-md"
                                    : "border-gray-300 bg-white hover:border-gray-400"
                                    }`}
                            >
                                <i className="fa-solid fa-user text-xl text-black mb-2"></i>
                                <span className="font-fontPoppins text-sm font-medium text-black">
                                    Myself
                                </span>
                            </button>

                            <button
                                onClick={() => setBookingFor("child")}
                                className={`flex flex-col items-center justify-center w-64 h-24 rounded-lg border-2 transition-all duration-200 ${bookingFor === "child"
                                    ? "border-black bg-white shadow-md"
                                    : "border-gray-300 bg-white hover:border-gray-400"
                                    }`}
                            >
                                <i className="fa-solid fa-users text-xl text-black mb-2"></i>
                                <span className="font-fontPoppins text-sm font-medium text-black">
                                    Child or Minor (Under 18)
                                </span>
                            </button>

                            <button
                                onClick={() => setBookingFor("someone_else")}
                                className={`flex flex-col items-center justify-center w-64 h-24 rounded-lg border-2 transition-all duration-200 ${bookingFor === "someone_else"
                                    ? "border-black bg-white shadow-md"
                                    : "border-gray-300 bg-white hover:border-gray-400"
                                    }`}
                            >
                                <i className="fa-solid fa-user-circle text-xl text-black mb-2"></i>
                                <span className="font-fontPoppins text-sm font-medium text-black">
                                    Someone Else (18+)
                                </span>
                            </button>
                        </div>
                    </div>

                    <div className="w-full my-4 md:flex md:justify-between md:gap-4">
                        <div className="w-full bg-gray-100 px-4 py-5 rounded-lg">
                            <h1 className="font-fontPoppins text-base font-semibold text-center mb-4">
                                {bookingFor === "myself" ? "Please Enter Your Exact Details" :
                                    "Please Enter Patient Details"}
                            </h1>
                            {bookingFor === "someone_else" && (
                                <div className="w-full mt-6">
                                    <h2 className="font-fontPoppins text-lg font-semibold text-gray-800 mb-3">
                                        Send appointment updates to:
                                    </h2>

                                    {/* Radio Button Selection */}
                                    <div className="w-full mb-4">
                                        <div className="flex flex-col space-y-3">
                                            <label className="flex items-center cursor-pointer">
                                                <input
                                                    type="radio"
                                                    name="sendUpdatesTo"
                                                    value="booker"
                                                    checked={sendUpdatesTo === "booker"}
                                                    onChange={(e) => setSendUpdatesTo(e.target.value)}
                                                    className="mr-3 w-4 h-4 text-blue-600"
                                                />
                                                <span className="font-fontPoppins text-sm font-medium text-black">
                                                    Person making this appointment
                                                </span>
                                            </label>

                                            <label className="flex items-center cursor-pointer">
                                                <input
                                                    type="radio"
                                                    name="sendUpdatesTo"
                                                    value="patient"
                                                    checked={sendUpdatesTo === "patient"}
                                                    onChange={(e) => setSendUpdatesTo(e.target.value)}
                                                    className="mr-3 w-4 h-4 text-blue-600"
                                                />
                                                <span className="font-fontPoppins text-sm font-medium text-black">
                                                    Patient: Will Book and Manage Appointment
                                                </span>
                                            </label>
                                        </div>
                                    </div>

                                    {/* Booker Information Form */}
                                    {sendUpdatesTo === "booker" && (
                                        <div className="w-full p-4 bg-blue-50 rounded-lg border border-blue-200">
                                            <div className="w-full mt-3">
                                                <div className="w-full mt-2 md:flex md:justify-between md:gap-3">
                                                    <div className="w-full">
                                                        <label className="w-full font-fontPoppins text-base font-medium">
                                                            First name<span className="text-red-500">*</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            placeholder="Enter First Name"
                                                            name="fname"
                                                            value={bookerData.fname}
                                                            onChange={handleBookerDataChange}
                                                            className="w-full h-11 xss:mt-3 sm:mt-3 md:mt-0 bg-white rounded-lg font-fontPoppins text-sm font-medium text-black shadow-sm px-3 focus:outline-none focus:ring focus:ring-gray-200"
                                                        />
                                                        {errors.bookerName && (
                                                            <p className="text-red-500 text-xs mt-1">{errors.bookerName}</p>
                                                        )}
                                                    </div>
                                                    <div className="w-full">
                                                        <label className="w-full font-fontPoppins text-base font-medium">
                                                            Last name<span className="text-red-500">*</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            placeholder="Enter Last Name"
                                                            name="lname"
                                                            value={bookerData.lname}
                                                            onChange={handleBookerDataChange}
                                                            className="w-full h-11 xss:mt-3 sm:mt-3 md:mt-0 bg-white rounded-lg font-fontPoppins text-sm font-medium text-black shadow-sm px-3 focus:outline-none focus:ring focus:ring-gray-200"
                                                        />
                                                        {errors.bookerName && (
                                                            <p className="text-red-500 text-xs mt-1">{errors.bookerName}</p>
                                                        )}
                                                    </div>

                                                </div>
                                            </div>

                                            <div className="w-full mt-2 md:flex md:justify-between md:gap-3">
                                                <div className="w-full mt-3 md:mt-0">
                                                    <label className="w-full font-fontPoppins text-base font-medium">
                                                        Email<span className="text-red-500">*</span>
                                                    </label>
                                                    <input
                                                        disabled={isEmailDisabled || isFieldDisabled}
                                                        type="text"
                                                        placeholder="Enter Your Email"
                                                        name="email"
                                                        value={bookerData.email || userData.email}
                                                        onChange={handleBookerDataChange}
                                                        className={`w-full h-11 bg-white rounded-lg font-fontPoppins text-sm font-medium text-black shadow-sm px-3 focus:outline-none focus:ring focus:ring-gray-200 ${isEmailDisabled || isFieldDisabled
                                                            ? "bg-gray-200 text-gray-500 cursor-not-allowed"
                                                            : ""
                                                            }`}
                                                    />
                                                    {errors.bookerEmail && (
                                                        <p className="text-red-500 text-xs mt-1">{errors.bookerEmail}</p>
                                                    )}

                                                    {/* OTP verification section for booker */}
                                                    {!(bookingFor === "someone_else" && sendUpdatesTo === "patient") &&
                                                        (bookingFor === "someone_else" && sendUpdatesTo === "booker" && patientId == null) &&
                                                        (sendOtp ? (
                                                            <div className="mt-3">
                                                                <input
                                                                    type="text"
                                                                    placeholder="Enter 6-digit verification code"
                                                                    name="otp"
                                                                    value={otp}
                                                                    onChange={handleOtpChange}
                                                                    maxLength={6}
                                                                    className="w-full h-11 bg-white rounded-lg font-fontPoppins text-sm font-medium text-black shadow-sm px-3 text-center tracking-widest focus:outline-none focus:ring focus:ring-gray-200"
                                                                />
                                                                <div className="flex justify-between items-center mt-2">
                                                                    <button
                                                                        className="bg-blue-500 hover:bg-blue-600 text-white font-fontPoppins py-1 px-3 rounded-full focus:outline-none"
                                                                        onClick={() =>
                                                                            handleVerifyOtp(
                                                                                otp,
                                                                                bookerData.email
                                                                            )
                                                                        }
                                                                    >
                                                                        Verify Code
                                                                    </button>

                                                                    {timerActive ? (
                                                                        <span className="font-fontPoppins text-sm text-gray-600">
                                                                            Resend in {countdown}s
                                                                        </span>
                                                                    ) : (
                                                                        <button
                                                                            type="button"
                                                                            onClick={() => handleResendVerification(bookerData.email)}
                                                                            disabled={loading}
                                                                            className="font-fontPoppins text-sm text-blue-500 hover:underline"
                                                                        >
                                                                            Resend Code
                                                                        </button>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        ) : (
                                                            <button
                                                                className="mt-2 bg-blue-500 hover:bg-blue-600 text-white font-fontPoppins py-2 px-4 rounded-full focus:outline-none"
                                                                onClick={() => handleVerifyEmail(bookerData.email)}
                                                            >
                                                                Send Verification Code
                                                            </button>
                                                        ))}
                                                </div>
                                                <div className="w-full mt-3 md:mt-0">
                                                    <label className="w-full font-fontPoppins text-base font-medium">
                                                        Phone<span className="text-red-500">*</span>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        placeholder="Enter Your Phone Number"
                                                        name="phone"
                                                        value={bookerData.phone}
                                                        maxLength={14}
                                                        onChange={handleBookerDataChange}
                                                        className="w-full h-11 bg-white rounded-lg font-fontPoppins text-sm font-medium text-black shadow-sm px-3 focus:outline-none focus:ring focus:ring-gray-200"
                                                    />
                                                    {errors.bookerPhone && (
                                                        <p className="text-red-500 text-xs mt-1">{errors.bookerPhone}</p>
                                                    )}
                                                </div>
                                            </div>

                                        </div>
                                    )}




                                    {/* Patient Contact Information Form */}
                                    {bookingFor === "someone_else" && sendUpdatesTo === "patient" && (
                                        <div className="w-full p-4 bg-green-50 rounded-lg border border-green-200 mt-6">
                                            <h3 className="font-fontPoppins text-base font-semibold text-gray-800 mb-3">
                                                Patient Contact Information
                                            </h3>
                                            <p className="font-fontPoppins text-sm text-gray-600 mb-4">
                                                Please provide the patient's contact info to share appointment booking details.
                                            </p>

                                            <div className="w-full mt-3">
                                                <div className="w-full mt-2 md:flex md:justify-between md:gap-3">
                                                    <div className="w-full">
                                                        <label className="w-full font-fontPoppins text-base font-medium">
                                                            First name<span className="text-red-500">*</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            placeholder="Enter Patient's First Name"
                                                            name="firstName"
                                                            value={patientContactData.firstName || ""}
                                                            onChange={handlePatientContactChange}
                                                            className="w-full h-11 xss:mt-3 sm:mt-3 md:mt-0 bg-white rounded-lg font-fontPoppins text-sm font-medium text-black shadow-sm px-3 focus:outline-none focus:ring focus:ring-gray-200"
                                                        />
                                                        {errors.patientContactFirstName && (
                                                            <p className="text-red-500 text-xs mt-1">{errors.patientContactFirstName}</p>
                                                        )}
                                                    </div>
                                                    <div className="w-full mt-3 md:mt-0">
                                                        <label className="w-full font-fontPoppins text-base font-medium">
                                                            Last name<span className="text-red-500">*</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            placeholder="Enter Patient's Last Name"
                                                            name="lastName"
                                                            value={patientContactData.lastName || ""}
                                                            onChange={handlePatientContactChange}
                                                            className="w-full h-11 bg-white rounded-lg font-fontPoppins text-sm font-medium text-black shadow-sm px-3 focus:outline-none focus:ring focus:ring-gray-200"
                                                        />
                                                        {errors.patientContactLastName && (
                                                            <p className="text-red-500 text-xs mt-1">{errors.patientContactLastName}</p>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="w-full mt-2 md:flex md:justify-between md:gap-3">
                                                <div className="w-full mt-3 md:mt-0">
                                                    <label className="w-full font-fontPoppins text-base font-medium">
                                                        Email<span className="text-red-500">*</span>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        placeholder="Enter Patient's Email"
                                                        name="email"
                                                        value={patientContactData.email || ""}
                                                        onChange={handlePatientContactChange}
                                                        className={`w-full h-11 bg-white rounded-lg font-fontPoppins text-sm font-medium text-black shadow-sm px-3 focus:outline-none focus:ring focus:ring-gray-200 ${isEmailDisabled || isFieldDisabled
                                                            ? "bg-gray-200 text-gray-500 cursor-not-allowed"
                                                            : ""
                                                            }`}
                                                    />
                                                    {errors.patientContactEmail && (
                                                        <p className="text-red-500 text-xs mt-1">{errors.patientContactEmail}</p>
                                                    )}

                                                </div>
                                            </div>
                                        </div>
                                    )}


                                </div>
                            )}
                            {/* Patient Details Section */}
                            {!(bookingFor === "someone_else" && sendUpdatesTo === "patient") && (
                                <div className="w-full mt-4">
                                    <h2 className="font-fontPoppins text-lg font-semibold text-gray-800 mb-3">
                                        Patient details
                                    </h2>
                                    <p className="font-fontPoppins text-sm text-gray-600 mb-4">
                                        Please provide the following information about the person receiving care.
                                    </p>

                                    {/* All the existing patient details form fields go here */}
                                    <div className="w-full mt-3">
                                        <div className="w-full mt-2 md:flex md:justify-between md:gap-3">
                                            <div className="w-full">
                                                <label className="w-full font-fontPoppins text-base font-medium">
                                                    Patient first name<span className="text-red-500">*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    placeholder="Enter First Name"
                                                    name="first_name"
                                                    value={userData.first_name}
                                                    onChange={handleChange}
                                                    className="w-full h-11 xss:mt-3 sm:mt-3 md:mt-0 bg-white rounded-lg font-fontPoppins text-sm font-medium text-black shadow-sm px-3 focus:outline-none focus:ring focus:ring-gray-200"
                                                />
                                                {errors.first_name && (
                                                    <p className="text-red-500 text-xs mt-1">
                                                        {errors.first_name}
                                                    </p>
                                                )}
                                            </div>
                                            <div className="w-full mt-3 md:mt-0">
                                                <label className="w-full font-fontPoppins text-base font-medium">
                                                    Patient last name<span className="text-red-500">*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    placeholder="Enter Last Name"
                                                    name="last_name"
                                                    value={userData.last_name}
                                                    onChange={handleChange}
                                                    className="w-full h-11 bg-white rounded-lg font-fontPoppins text-sm font-medium text-black shadow-sm px-3 focus:outline-none focus:ring focus:ring-gray-200"
                                                />
                                                {errors.last_name && (
                                                    <p className="text-red-500 text-xs mt-1">{errors.last_name}</p>
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="w-full mt-3 md:flex md:justify-between md:gap-3">
                                        <div className="w-full">
                                            <label className="w-full font-fontPoppins text-base font-medium">
                                                Patient legal sex<span className="text-red-500">*</span>
                                            </label>
                                            <CustomSelect
                                                options={[
                                                    { value: "male", label: "Male" },
                                                    { value: "female", label: "Female" },
                                                ]}
                                                name="gender"
                                                onChange={(e) => handleChange(e)}
                                                value={userData.gender}
                                                placeholder="Select Sex"
                                            />
                                            {errors.gender && (
                                                <p className="text-red-500 text-xs mt-1">{errors.gender}</p>
                                            )}
                                        </div>
                                        <div className="w-full mt-3 md:mt-0">
                                            <label className="w-full font-fontPoppins text-base font-medium">
                                                Patient date of birth<span className="text-red-500">*</span>
                                            </label>
                                            <ReactDatePicker
                                                selected={
                                                    userData.date_of_birth
                                                        ? new Date(userData.date_of_birth)
                                                        : null
                                                }
                                                onChange={(date) =>
                                                    setUserData((prevUserData) => ({
                                                        ...prevUserData,
                                                        date_of_birth: date,
                                                    }))
                                                }
                                                placeholderText="MM/DD/YYYY"
                                                className="w-full h-11 bg-white rounded-lg font-fontPoppins text-sm font-medium text-black shadow-sm px-3 focus:outline-none focus:ring focus:ring-gray-200"
                                                showMonthDropdown
                                                showYearDropdown
                                                dropdownMode="select"
                                                maxDate={today}
                                            />
                                            {errors.date_of_birth && (
                                                <p className="text-red-500 text-xs mt-1">
                                                    {errors.date_of_birth}
                                                </p>
                                            )}
                                        </div>
                                    </div>

                                    <div className="w-full mt-3">
                                        <label className="w-full font-fontPoppins text-base font-medium">
                                            Patient zip/postal code<span className="text-red-500">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            placeholder="Enter Zip Code"
                                            name="zipcode"
                                            value={userData.zipcode}
                                            maxLength={10}
                                            onChange={handleChange}
                                            className="w-full h-11 bg-white rounded-lg font-fontPoppins text-sm font-medium text-black shadow-sm px-3 focus:outline-none focus:ring focus:ring-gray-200"
                                        />
                                        {errors.zipcode && (
                                            <p className="text-red-500 text-xs mt-1">{errors.zipcode}</p>
                                        )}
                                    </div>

                                    <div className="w-full mt-3">
                                        <label className="w-full font-fontPoppins text-base font-medium">
                                            Reason For Visit<span className="text-red-500">*</span>
                                            <span className="text-f11 text-gray-300">
                                                {" "}
                                                (In 140 Characters)
                                            </span>
                                        </label>
                                        <textarea
                                            placeholder="Enter Reason"
                                            name="reasonForVisit"
                                            value={userData.reasonForVisit}
                                            onChange={handleChange}
                                            maxLength={140}
                                            className="w-full h-24 bg-white rounded-md font-fontPoppins text-sm font-medium text-black shadow-sm px-3 py-2 focus:outline-none focus:ring focus:ring-gray-200"
                                        ></textarea>
                                        {errors.reasonForVisit && (
                                            <p className="text-red-500 text-xs mt-1">
                                                {errors.reasonForVisit}
                                            </p>
                                        )}
                                    </div>
                                </div>
                            )}

                            {/* Parent/Guardian Details Section - Only for child bookings */}
                            {bookingFor === "child" && (
                                <div className="w-full mt-6">
                                    <h2 className="font-fontPoppins text-lg font-semibold text-gray-800 mb-3">
                                        Send appointment updates to:
                                    </h2>
                                    <p className="font-fontPoppins text-sm text-gray-600 mb-4">
                                        As the parent/guardian, appointment notifications will be sent to you.
                                    </p>

                                    {/* Relationship to Patient */}
                                    <div className="w-full mb-4">
                                        <label className="w-full font-fontPoppins text-base font-medium">
                                            What is your relationship with the patient (child or minor)?<span className="text-red-500">*</span>
                                        </label>
                                        <CustomSelect
                                            options={[
                                                { value: "parent", label: "Parent" },
                                                { value: "guardian", label: "Guardian" },
                                            ]}
                                            name="relationship"
                                            onChange={(e) => setRelationshipToPatient(e.target.value)}
                                            value={relationshipToPatient}
                                            placeholder="Select Relationship"
                                        />
                                        {errors.relationship && (
                                            <p className="text-red-500 text-xs mt-1">{errors.relationship}</p>
                                        )}
                                    </div>

                                    <div className="w-full mt-3">
                                        <div className="w-full mt-2 md:flex md:justify-between md:gap-3">
                                            <div className="w-full">
                                                <label className="w-full font-fontPoppins text-base font-medium">
                                                    Parent/Guardian first name<span className="text-red-500">*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    placeholder="Enter First Name"
                                                    name="first_name"
                                                    value={parentGuardianData.first_name}
                                                    onChange={handleParentGuardianChange}
                                                    className="w-full h-11 xss:mt-3 sm:mt-3 md:mt-0 bg-white rounded-lg font-fontPoppins text-sm font-medium text-black shadow-sm px-3 focus:outline-none focus:ring focus:ring-gray-200"
                                                />
                                                {errors.parentFirstName && (
                                                    <p className="text-red-500 text-xs mt-1">{errors.parentFirstName}</p>
                                                )}
                                            </div>
                                            <div className="w-full mt-3 md:mt-0">
                                                <label className="w-full font-fontPoppins text-base font-medium">
                                                    Parent/Guardian last name<span className="text-red-500">*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    placeholder="Enter Last Name"
                                                    name="last_name"
                                                    value={parentGuardianData.last_name}
                                                    onChange={handleParentGuardianChange}
                                                    className="w-full h-11 bg-white rounded-lg font-fontPoppins text-sm font-medium text-black shadow-sm px-3 focus:outline-none focus:ring focus:ring-gray-200"
                                                />
                                                {errors.parentLastName && (
                                                    <p className="text-red-500 text-xs mt-1">{errors.parentLastName}</p>
                                                )}
                                            </div>
                                        </div>
                                        <div className="w-full mt-2 md:flex md:justify-between md:gap-3">
                                            <div className="w-full mt-3 md:mt-0">
                                                <label className="w-full font-fontPoppins text-base font-medium">
                                                    Email<span className="text-red-500">*</span>
                                                </label>
                                                <input
                                                    disabled={isEmailDisabled || isFieldDisabled}
                                                    type="text"
                                                    placeholder="Enter Your Email"
                                                    name="email"
                                                    value={bookerData.email}
                                                    onChange={handleBookerDataChange}
                                                    className={`w-full h-11 bg-white rounded-lg font-fontPoppins text-sm font-medium text-black shadow-sm px-3 focus:outline-none focus:ring focus:ring-gray-200 ${isEmailDisabled || isFieldDisabled
                                                        ? "bg-gray-200 text-gray-500 cursor-not-allowed"
                                                        : ""
                                                        }`}
                                                />
                                                {errors.bookerEmail && (
                                                    <p className="text-red-500 text-xs mt-1">{errors.bookerEmail}</p>
                                                )}

                                                {/* OTP verification section for child bookings */}
                                                {(bookingFor === "child" && patientId == null) &&
                                                    (sendOtp ? (
                                                        <div className="mt-3">
                                                            <input
                                                                type="text"
                                                                placeholder="Enter 6-digit verification code"
                                                                name="otp"
                                                                value={otp}
                                                                onChange={handleOtpChange}
                                                                maxLength={6}
                                                                className="w-full h-11 bg-white rounded-lg font-fontPoppins text-sm font-medium text-black shadow-sm px-3 text-center tracking-widest focus:outline-none focus:ring focus:ring-gray-200"
                                                            />
                                                            <div className="flex justify-between items-center mt-2">
                                                                <button
                                                                    className="bg-blue-500 hover:bg-blue-600 text-white font-fontPoppins py-1 px-3 rounded-full focus:outline-none"
                                                                    onClick={() =>
                                                                        handleVerifyOtp(
                                                                            otp,
                                                                            bookerData.email
                                                                        )
                                                                    }
                                                                >
                                                                    Verify Code
                                                                </button>

                                                                {timerActive ? (
                                                                    <span className="font-fontPoppins text-sm text-gray-600">
                                                                        Resend in {countdown}s
                                                                    </span>
                                                                ) : (
                                                                    <button
                                                                        type="button"
                                                                        onClick={() => handleResendVerification(bookerData.email)}
                                                                        disabled={loading}
                                                                        className="font-fontPoppins text-sm text-blue-500 hover:underline"
                                                                    >
                                                                        Resend Code
                                                                    </button>
                                                                )}
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <button
                                                            className="mt-2 bg-blue-500 hover:bg-blue-600 text-white font-fontPoppins py-2 px-4 rounded-full focus:outline-none"
                                                            onClick={() => handleVerifyEmail(bookerData.email)}
                                                        >
                                                            Send Verification Code
                                                        </button>
                                                    ))}
                                            </div>
                                            <div className="w-full">
                                                <label className="w-full font-fontPoppins text-base font-medium">
                                                    Phone<span className="text-red-500">*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    placeholder="Enter Your Phone Number"
                                                    name="phone"
                                                    value={bookerData.phone}
                                                    maxLength={14}
                                                    onChange={handleBookerDataChange}
                                                    className="w-full h-11 bg-white rounded-lg font-fontPoppins text-sm font-medium text-black shadow-sm px-3 focus:outline-none focus:ring focus:ring-gray-200"
                                                />
                                                {errors.bookerPhone && (
                                                    <p className="text-red-500 text-xs mt-1">{errors.bookerPhone}</p>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}



                            {/* Contact Information - For "Myself" or when not sending to patient */}
                            {(bookingFor === "myself") && (
                                <div className="w-full mt-6">
                                    <h2 className="font-fontPoppins text-lg font-semibold text-gray-800 mb-3">
                                        {bookingFor === "myself" ? "Contact Information" : "Your Contact Information"}
                                    </h2>

                                    <div className="w-full mt-3 md:flex md:justify-between md:gap-3">
                                        <div className="w-full">
                                            <label className="w-full font-fontPoppins text-base font-medium">
                                                Email<span className="text-red-500">*</span>
                                            </label>
                                            <input
                                                disabled={isEmailDisabled || isFieldDisabled}
                                                type="text"
                                                placeholder="Enter Your Email"
                                                name="email"
                                                value={userData.email}
                                                onChange={handleChange}
                                                className={`w-full h-11 bg-white rounded-lg font-fontPoppins text-sm font-medium text-black shadow-sm px-3 focus:outline-none focus:ring focus:ring-gray-200 ${isEmailDisabled || isFieldDisabled
                                                    ? "bg-gray-200 text-gray-500 cursor-not-allowed"
                                                    : ""
                                                    }`}
                                            />
                                            {errors.email && (
                                                <p className="text-red-500 text-xs mt-1">{errors.email}</p>
                                            )}
                                            {manualDetailsEntered &&
                                                (sendOtp ? (
                                                    <div className="mt-3">
                                                        <input
                                                            type="text"
                                                            placeholder="Enter 6-digit verification code"
                                                            name="otp"
                                                            value={otp}
                                                            onChange={handleOtpChange}
                                                            maxLength={6}
                                                            className="w-full h-11 bg-white rounded-lg font-fontPoppins text-sm font-medium text-black shadow-sm px-3 text-center tracking-widest focus:outline-none focus:ring focus:ring-gray-200"
                                                        />
                                                        <div className="flex justify-between items-center mt-2">
                                                            <button
                                                                className="bg-blue-500 hover:bg-blue-600 text-white font-fontPoppins py-1 px-3 rounded-full focus:outline-none"
                                                                onClick={() =>
                                                                    handleVerifyOtp(
                                                                        otp,
                                                                        userData.email
                                                                    )
                                                                }
                                                            >
                                                                Verify Code
                                                            </button>

                                                            {timerActive ? (
                                                                <span className="font-fontPoppins text-sm text-gray-600">
                                                                    Resend in {countdown}s
                                                                </span>
                                                            ) : (
                                                                <button
                                                                    type="button"
                                                                    onClick={() => handleResendVerification(userData.email)}
                                                                    disabled={loading}
                                                                    className="font-fontPoppins text-sm text-blue-500 hover:underline"
                                                                >
                                                                    Resend Code
                                                                </button>
                                                            )}
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <button
                                                        className="mt-2 bg-blue-500 hover:bg-blue-600 text-white font-fontPoppins py-2 px-4 rounded-full focus:outline-none"
                                                        onClick={() => handleVerifyEmail(userData.email)}
                                                    >
                                                        Send Verification Code
                                                    </button>
                                                ))}
                                        </div>
                                        <div className="w-full mt-3 md:mt-0">
                                            <label className="w-full font-fontPoppins text-base font-medium">
                                                Phone<span className="text-red-500">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                placeholder="Enter Your Contact Number"
                                                name="phone"
                                                value={userData.phone}
                                                maxLength={14}
                                                onChange={handleChange}
                                                className="w-full h-11 bg-white rounded-lg font-fontPoppins text-sm font-medium text-black shadow-sm px-3 focus:outline-none focus:ring focus:ring-gray-200"
                                            />
                                            {errors.phone && (
                                                <p className="text-red-500 text-xs mt-1">{errors.phone}</p>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* Stripe Credit Card Section */}
                            {!(bookingFor === "someone_else" && sendUpdatesTo === "patient") && clinicInfo.is_card === 1 && (
                                <div className="w-full mt-6 p-4 border border-gray-200 rounded-lg bg-white shadow-sm">
                                    <h2 className="font-fontPoppins text-base font-semibold text-gray-800 mb-1">
                                        {clinicInfo.name} requires a credit or debit card to schedule an appointment.
                                    </h2>
                                    <p className="font-fontPoppins text-sm text-gray-600 mb-4">
                                        Your card will not be charged at this time.
                                    </p>

                                    <div className="w-full">
                                        <label className="w-full font-fontPoppins text-base font-medium mb-2 block">
                                            Card Details<span className="text-red-500">*</span>
                                        </label>
                                        <div className="w-full p-3 bg-white rounded-lg border border-gray-300 focus-within:border-blue-500 focus-within:ring-1 focus-within:ring-blue-500">
                                            <CardElement
                                                options={{
                                                    style: {
                                                        base: {
                                                            color: '#424770',
                                                            fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                                                            fontSmoothing: 'antialiased',
                                                            fontSize: '16px',
                                                            '::placeholder': {
                                                                color: '#aab7c4',
                                                            },
                                                        },
                                                        invalid: {
                                                            color: '#9e2146',
                                                            iconColor: '#9e2146',
                                                        },
                                                    },
                                                    hidePostalCode: true,
                                                }}
                                                onChange={handleCardChange}
                                            />
                                        </div>
                                        {(errors.card || cardError) && (
                                            <p className="text-red-500 text-xs mt-1">{errors.card || cardError}</p>
                                        )}
                                    </div>

                                    <div className="mt-4 p-3 bg-gray-50 rounded-md">
                                        <p className="text-xs text-black font-fontPoppins leading-relaxed">
                                            No Shows and cancellations made within 2 hours from your appointment time may result in a
                                            {clinicInfo.no_show_fee !== 0 ? ` $${clinicInfo.no_show_fee}` : ''} fee.
                                            Cancellations made prior to 2 hours from your appointment time will not result in a fee. Any waiver of the fee is at the sole discretion of {clinicInfo.name}.
                                        </p>
                                    </div>
                                </div>
                            )}

                            <div className="w-full m-3">
                                <ReCAPTCHA
                                    sitekey="6LeQUPYpAAAAAB_WZcNRTsEhk-zC4ktXWLLO16Rb"
                                    onChange={onChange}
                                    ref={recaptchaRef}
                                />
                            </div>
                            {captchError && (
                                <p className="text-red-500 text-xs">{captchError}</p>
                            )}
                        </div>

                        {!(bookingFor === "someone_else" && sendUpdatesTo === "patient") && (

                            <div className="w-full bg-gray-100 px-4 py-5 rounded-xl xss:mt-3 sm:mt-3 md:mt-0">
                                <h1 className="font-fontPoppins text-base font-semibold text-center">
                                    Appointment Details:
                                </h1>

                                <div className="w-full mt-4">
                                    <h2 className="font-fontPoppins text-sm font-medium text-black-100">
                                        Appointment
                                    </h2>
                                    <p className="font-fontPoppins text-sm font-semibold text-black">
                                        {/* {patientTypeName} |  */}
                                        {verified && patientTypeName && `${patientTypeName} | `}
                                        {appoinmentName.services} <br />
                                        {appointmentData.available_date_time_new}
                                    </p>
                                </div>
                                <div className="w-full mt-4">
                                    <h2 className="font-fontPoppins text-sm font-medium text-black-100">
                                        Appointment Duration
                                    </h2>
                                    <p className="font-fontPoppins text-sm font-semibold text-black">
                                        {appoinmentName.duration} minutes.
                                    </p>
                                </div>

                                <div className="w-full mt-4">
                                    <h2 className="font-fontPoppins text-sm font-medium text-black-100">
                                        Address
                                    </h2>
                                    <p className="font-fontPoppins text-sm font-semibold text-black">
                                        {address && address}
                                        <br />
                                        <p>{phone && phone}</p>
                                    </p>
                                </div>

                                <div className="w-full mt-4">
                                    <h2 className="font-fontPoppins text-sm font-medium text-black-100">
                                        Consulting Practitioner
                                    </h2>
                                    <p className="font-fontPoppins text-sm font-semibold text-black">
                                        {doctorDetail?.f_name
                                            ? `${doctorDetail?.f_name} ${doctorDetail?.l_name}`
                                            : `${doctorName?.f_name} ${doctorName?.l_name}`}
                                        <span className="text-gray-700">
                                            {` (${doctorDetail?.taxonomy_description?.trim() ||
                                                doctorName?.taxonomy_description?.trim()
                                                })`}
                                        </span>
                                    </p>
                                </div>

                                {(insuranceType === "other" ||
                                    insuranceType === "noInsurance") && (
                                        <div className="w-full mt-4">
                                            <h2 className="font-fontPoppins text-sm font-medium text-black-100">
                                                Insurance Type
                                            </h2>
                                            <p className="font-fontPoppins text-sm font-semibold text-black">
                                                {insuranceName}
                                            </p>
                                        </div>
                                    )}
                                {insuranceType !== "other" && insuranceType !== "noInsurance" && (
                                    <div className="w-full mt-4">
                                        <h2 className="font-fontPoppins text-sm font-medium text-black-100">
                                            Insurance Carrier
                                        </h2>
                                        <p className="font-fontPoppins text-sm font-semibold text-black">
                                            {
                                                insuranceName?.health_insurance_carrier_master
                                                    ?.health_insurance_carrier_name
                                            }
                                        </p>
                                    </div>
                                )}
                            </div>
                        )}

                    </div>

                    <div className="w-full mt-4 text-center">
                        <button
                            onClick={handleSubmit}
                            className={`w-56 h-10 font-fontPoppins bg-blueColor text-xs rounded-full text-white font-semibold hover:opacity-85 ${!verified ? "cursor-not-allowed" : ""
                                }`}
                            disabled={!verified}
                        >
                            {(bookingFor === "someone_else" && sendUpdatesTo === "patient")
                                ? "Share Appointment "
                                : "Book Your Appointment "
                            }
                            <i className="fa-solid fa-arrow-right-long"></i>
                        </button>

                        {/* Fine Print - Hide when someone_else + patient is selected */}
                        {!(bookingFor === "someone_else" && sendUpdatesTo === "patient") && (
                            <div className="mt-4 max-w-2xl mx-auto">
                                <p className="text-xs text-black font-fontPoppins leading-relaxed text-left">
                                    I understand that this form is using Google's reCaptcha to verify requests. By providing your phone number, you consent to receiving SMS text messages and phone calls from {Clinicname} relating to my appointments, including texts and calls that promote our products and services. Text messages and data rates may apply. You may withdraw your consent at any time. Reply STOP to any text message to unsubscribe, or HELP for more options.
                                </p>
                            </div>
                        )}
                    </div>

                </div>
            </section >
        </>
    );
}

export default ClinicPersonalAppointmentDetailsWrapper;